import { Instagram, Music2, Heart } from "lucide-react";

const tiles = [
  { url: "https://customer-assets.emergentagent.com/job_miss-lolly-designs/artifacts/22257des_IMG_6302.jpeg", caption: "MLD HEART" },
  { url: "https://customer-assets.emergentagent.com/job_miss-lolly-designs/artifacts/tbx4j2t8_IMG_4157.jpeg", caption: "SANRIO COAT" },
  { url: "https://customer-assets.emergentagent.com/job_miss-lolly-designs/artifacts/opf801d8_IMG_2658.jpeg", caption: "LYRIC COLLAGE" },
  { url: "https://images.unsplash.com/photo-1565878025229-b4029f4f7038?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", caption: "NEON DRIP" },
  { url: "https://images.unsplash.com/photo-1775176729481-66efe89117b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", caption: "STREET STYLE" },
  { url: "https://images.unsplash.com/photo-1536639335969-19c9bfc0a4c7?crop=entropy&cs=srgb&fm=jpg&q=85&w=600", caption: "STUDIO MOOD" },
];

export default function SocialEmbed() {
  return (
    <section data-testid="social-embed" className="section-y bg-coal border-y-2 border-white/10">
      <div className="container-x">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
          <div>
            <p className="overline">@misslollydesigns</p>
            <h2 className="mt-3 font-display text-5xl md:text-6xl text-white">On the feed.</h2>
          </div>
          <div className="flex gap-3">
            <a href="https://www.instagram.com/misslollydesigns" target="_blank" rel="noreferrer" data-testid="ig-link"
               className="btn-secondary text-xs"><Instagram size={14} /> IG</a>
            <a href="https://tiktok.com" target="_blank" rel="noreferrer" data-testid="tt-link"
               className="btn-secondary text-xs"><Music2 size={14} /> TIKTOK</a>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {tiles.map((t, i) => (
            <a key={t.url} href="https://www.instagram.com/misslollydesigns" target="_blank" rel="noreferrer"
               data-testid={`social-tile-${i}`}
               className="group relative aspect-square overflow-hidden border-2 border-white bg-coal">
              <img src={t.url} alt={t.caption} loading="lazy"
                   className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
              <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/60 transition-colors" />
              <div className="absolute bottom-2 left-2 right-2 flex items-center gap-1 text-white opacity-0 group-hover:opacity-100 transition">
                <Heart size={12} className="fill-rose text-rose" />
                <span className="text-[10px] uppercase tracking-wider font-bold">{t.caption}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
